import jss from 'jss';
import preset from 'jss-preset-default';
import $ from "jquery";
import "slick-carousel";
import { generateVectorPosition } from 'Client/utils/vector-position'
import { NonceProvider } from 'react-select';
let widthDevice = window.innerWidth;
class WidgetEditor2ColBox extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                slides: '#ecf_opportunities_for_volunteers .slider--active ',
                slideItem: '#ecf_opportunities_for_volunteers .slider--active  .ecf_editor_2_col_box__content-item',
                img: ".background-img-position .img-position-item",
                labelClick: '.subtitle-content-right',
            },
        };
    }
    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $slides: this.$element.find(selectors.slides),
            $slideItem: this.$element.find(selectors.slideItem),
            $img: this.$element.find(selectors.img),
            $labelClick: this.$element.find(selectors.labelClick),
        };
    }
    getWidth(element,width){
        if(element){
            jss.setup(preset())
            const styles = {
                width_process:{
                    width:`${width}% !important`,
                }
            }

            const {classes} = jss.createStyleSheet(styles).attach()
            element.classList.add(classes.width_process)
        }
    }
    changeStatusProcess(number,slick){
        let onProgress = number + 1;
        let loadProgress = (onProgress / slick.slideCount) * 100;
        return loadProgress;
    }
    startSlick(slider,lengthSliderItem,THIS,processBar){
        slider.on(
            "init",
            function (event, slick, currentSlide, nextSlide) {
                THIS.getWidth(processBar,THIS.changeStatusProcess(0,slick));
            }
        );
    }
    beforeChangeSlick(slider,lengthSliderItem,THIS,processBar){
        slider.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
                let slick_list = $(".slick-list");
                let onProgress = nextSlide+3;
                THIS.getWidth(processBar,THIS.changeStatusProcess(nextSlide,slick));
            }
        );
    }
    initStyle(modal){
        jss.setup(preset())
        const styles = {
            modal:{
                display: 'block',
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex:10000,
                '& .lightbox-container': {
                    position: 'relative',
                    zIndex: 2,
                    height: '100%',
                },
                '& > .ecf-lightbox__bg':{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    background: '#EAEDF5',
                    opacity: 0.8,
                    zIndex: 1,
                },
                '& .subtitle-content-right':{
                    'marginBottom':'16px',
                    'paddingRight': '24px',
                    'fontSize':'14px',
                    'lineHeight':'20px',
                    '& strong':{
                        color:'#b42a22',
                    },
                },
                '& .content':{
                    '& .content-container':{
                        '& li':{
                            'marginBottom':'16px',
                            'paddingLeft':'24px',
                            '&:nth-last-child(1)':{
                                'marginBottom':'0px',
                            },
                        }
                    }
                },
                '& .ecf-lightbox__container': {
                    background: '#FFFFFF',
                    mixBlendMode: 'normal',
                    boxShadow: [0, 0, '16px', '#EAEDF5'],
                    borderRadius: '16px',
                    position: 'relative',
                    '@media screen and (max-width: 560px)':{
                        padding: [21,24,40,24]
                    },
                    zIndex: 2,
                    '& .ecf-lightbox__close': {
                        position: 'absolute',
                        top: 21,
                        right: 26,
                        zIndex: 20,
                        cursor: 'pointer',
                        '& i': {
                            fontSize: 24,
                            color:'#354C74',
                        }
                    },
                }
            }
        }
        const {classes} = jss.createStyleSheet(styles).attach()
        modal.classList.add(classes.modal)
    }

    renderModalHTML(data){
        return `
            <div class="ecf-lightbox justify-content-center align-items-center">
                <div class="ecf-lightbox__bg"></div>
                <div class="d-flex container justify-content-center align-items-center lightbox-container">
                     <div class="ecf-lightbox__container col-12">
                        <div class="ecf-lightbox__close">
                            <i class="fal fa-times"></i>
                        </div>
                        <div class="ecf-lightbox__content ecf-content-col_modal">
                            ${data}
                        </div>
                     </div>
                </div>
                </div>
            </div>
        `
    }

    createModal(data,THIS){
        let modal = document.querySelector('.ecf-lightbox')
        let body = document.querySelector('body')
        let html = document.querySelector('html')
        modal && modal.remove()
        const MODAL_HTML = THIS.renderModalHTML(data)
        html.classList.add('active')
        body.insertAdjacentHTML('beforeend',MODAL_HTML)
        modal = document.querySelector('.ecf-lightbox')
        THIS.initStyle(modal)
    }

    closeModal(){
        let modal = document.querySelector('.ecf-lightbox')
        let html = document.querySelector('html')
        let closeBTN  = document.querySelector('.ecf-lightbox .ecf-lightbox__close')
        let closeBG = document.querySelector('.ecf-lightbox .ecf-lightbox__bg')
        closeBTN && closeBTN.addEventListener('click', () =>{
            html.classList.remove('active')
            modal && modal.remove()
        })
        closeBG && closeBG.addEventListener('click', () =>{
            html.classList.remove('active')
            modal && modal.remove()
        })
    }
    handShowPopup(data,THIS){
        THIS.createModal(data,THIS)
        THIS.closeModal()
    }
    bindEvents() {
        const THIS = this;
        let slides = this.elements.$slides[0];
        let slideItem = this.elements.$slideItem;
        let img_abs = this.elements.$img;
        let widthDevice= window.outerWidth;
        let labelClick = Array.prototype.slice.call(this.elements.$labelClick);
        if(img_abs.length!=0){
            img_abs.each(function(index, element){
                let dataPosition = element.getAttribute('data-position');
                let dataResponsive = element.getAttribute('data-responsive');
                let defaultObj = JSON.parse(atob(dataPosition))
                let responsive = JSON.parse(atob(dataResponsive))
                generateVectorPosition(defaultObj, responsive, element);
            });
        }
        if(slides){
            let idProcess = `Process${slides.getAttribute('id')}`;
            let processBarContainer = document.querySelector(
                `#${idProcess}.ecf-process-bar`
            );
            let btnModal = document.querySelectorAll('.btn-text-modal a');
            let widthDevice = window.innerWidth;
            let processBar = document.querySelector(`#${idProcess}.ecf-process-bar .process`);
            let lengthSliderItem = slideItem.length;
            processBarContainer.classList.add('d-lg-block')
            let boxContentList = $('.ecf_editor_2_col_box__content-list')
            let boxContent = $('.ecf_editor_2_col_box__content');
            let boxContentItem = Array.prototype.slice.call(
                $('.ecf_editor_2_col_box__content-item')
            );
            let colBoxContainer = $('.ecf_editor_2_col_box__container');
            if(btnModal.length!=0){
                btnModal.forEach((item)=>{
                    item.addEventListener('click',()=>{
                        let contentModal = item.closest('.ecf-carousel-item-container').querySelector('.col-right .col-right-content');
                        if(contentModal){
                            contentModal = contentModal.innerHTML
                        }else{ return }
                        THIS.handShowPopup(contentModal,THIS)
                    })
                })
            }
            
            
            if (slides) {
                if(widthDevice >= 1023){
                    THIS.startSlick($(slides),lengthSliderItem,THIS,processBar)
                }
                if(widthDevice >= 1023){
                    THIS.beforeChangeSlick($(slides),lengthSliderItem,THIS,processBar);
                }
                $(slides).slick({
                    // initialSlide: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    variableWidth: true,
                    focusOnSelect: true,
                    nextArrow: '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next slick-arrow">Next</button>',
                    prevArrow: '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev slick-arrow">Previous</button>',
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows:false,
                                variableWidth: false,
                                dots: true,
                            },
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                arrows:false,
                                variableWidth: false,
                                centerMode: true,
                                centerPadding: "13px",
                            },
                        },
                        {
                            breakpoint: 321,
                            settings: {
                                arrows:false,
                                variableWidth: false,
                                centerMode: true,
                                centerPadding: "13px",
                            },
                        },
                    ],
                })
            }
        }else{
            if(labelClick.length!=0 && widthDevice<=767){
                labelClick.forEach((item)=>{
                    item.addEventListener("click",()=>{
                        let contentActive = item.closest('.col-right-content').querySelector('.content');
                        let contentHeight = contentActive.querySelector('.content-container').offsetHeight;
                        contentActive.classList.toggle('active');
                        item.classList.toggle('dropdown');
                        if(contentActive.classList.contains('active')){
                            for(let i=1;i<=contentHeight;i++){
                                setTimeout(()=>{
                                    contentActive.style.height = `${i}px`;
                                },20)
                            }
                        }else{
                            contentActive.style.height = `${0}px`;
                        }
                    });
                })
            }
        }
    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetEditor2ColBox, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction('frontend/element_ready/ecf_editor_2_col_box.default', addHandler);
});
